import { jsx, jsxs } from "react/jsx-runtime";
import { Layout, Box, Heading, Stack, Spacer } from "@contember/ui";
import { memo } from "react";
const MiscPageLayout = memo(({ footerActions, heading, children, ...props }) => /* @__PURE__ */ jsx(Layout, { children: /* @__PURE__ */ jsx("div", { className: "centerCard", children: /* @__PURE__ */ jsxs("div", { className: "centerCard-in", children: [
  /* @__PURE__ */ jsx(
    Box,
    {
      gap: "large",
      heading: heading && (typeof heading === "string" ? /* @__PURE__ */ jsx(Heading, { depth: 1, size: "small", children: heading }) : heading),
      ...props,
      children: /* @__PURE__ */ jsx(Stack, { direction: "vertical", gap: "large", children })
    }
  ),
  footerActions && /* @__PURE__ */ jsxs("div", { style: { position: "sticky", bottom: 0 }, children: [
    /* @__PURE__ */ jsx(Spacer, { gap: "large" }),
    /* @__PURE__ */ jsx(Stack, { direction: "horizontal", children: footerActions })
  ] })
] }) }) }));
MiscPageLayout.displayName = "MiscPageLayout";
export {
  MiscPageLayout
};
//# sourceMappingURL=MiscPageLayout.js.map
